import React, { useEffect, useState } from 'react';
import { Token, useApiIntegrations } from 'src/common/api/use-integrations.hook';
import LoadingSpinnerLight from 'src/common/components/loading-spinner/light';
import classNames from 'classnames';
import { IntegrationConnectButton } from './connect-button';
import LoadingSpinner from 'src/common/components/loading-spinner';
import { IntegrationMicrosoftOneDrivePickerButton } from './microsoft-one-drive-picker-button';

type Props = {
  onNewUrl: (url: string, title: string) => void;
};

export const IntegrationMicrosoftOneDrivePanel = ({
  onNewUrl,
}: Props) => {
  const [loaded, setLoaded] = useState(false);
  const { fetchAccessTokens } = useApiIntegrations();

  const [tokens, setTokens] = useState<Token[]>([]);

  const loadTokens = () => {
    fetchAccessTokens('microsoft-one-drive').then((tokens: Token[]) => {
      setTokens(tokens);
      setLoaded(true);
    }).catch((err) => {
      setLoaded(false);
    });
  }

  useEffect(() => {
    loadTokens();
  }, []);

  const onFileSelected = (embedUrl: string, title: string) => {
    onNewUrl(embedUrl, title);
  };

  if (loaded && tokens.length === 0) {
    return (
      <div className="flex flex-col space-y-4 text-neue-journey-fg">
        <div className="text-bedrock-p-small">
          Connect Microsoft One Dirve account to quickly import content into Journey
        </div>
        <IntegrationConnectButton onIntegrationConnected={loadTokens} provider={'google-drive'} />
      </div>
    )
  }

  return (
    <div className='flex flex-col space-y-4 h-full w-full overflow-y-auto'>
      {tokens.map((token: Token) => (
        <div className="flex flex-col space-y-4">
          <div className="text-bedrock-p-small">Connected to: {token.email}</div>
          <IntegrationMicrosoftOneDrivePickerButton
            token={token}
            onFileSelected={onFileSelected}>
          </IntegrationMicrosoftOneDrivePickerButton>
        </div>
      ))}
      {!loaded && <LoadingSpinner containerClassName={classNames('h-full')} />}
    </div>
  )
}